export default {
  ascending: true,
  prop: 'category_name',
  rowTriggerClass: 'table-row table-row__group-trigger'
};



// WEBPACK FOOTER //
// ./src/table_module/configs/rows_grouping.js